import { ChatReportReason, InboxFilter } from '@/types/chat';

/** Inbox rows per page (the server caps it at 50). */
export const CHAT_INBOX_PAGE_SIZE = 20;
/** Members per page (the server caps it at 100). */
export const CHAT_MEMBERS_PAGE_SIZE = 50;
/**
 * A DM request's one message is already used: nothing more until the other person accepts. A state
 * to explain, not a failure to flag.
 */
export const CHAT_REQUEST_PENDING_CODE = 'CHAT_REQUEST_PENDING';
/** Unread counts above this show as "99+". */
export const CHAT_UNREAD_BADGE_MAX = 99;
/** Socket-driven refreshes of the unread total wait for a burst of frames to settle this long… */
export const CHAT_UNREAD_REFRESH_DEBOUNCE_MS = 1_000;
/** …but never longer than this, so a busy chat can't hold the badge back indefinitely. */
export const CHAT_UNREAD_REFRESH_MAX_WAIT_MS = 5_000;
/** Mirrors the server's cap on how many chats one share can go to. */
export const CHAT_SHARE_MAX_CONVERSATIONS = 10;
/** Mirrors the server's cap on a report's description. */
export const CHAT_REPORT_DESCRIPTION_MAX_LENGTH = 1000;
/** Mirrors the server's group title limit. */
export const CHAT_GROUP_TITLE_MAX_LENGTH = 60;
/** A group holds at most 100 people, the creator included. */
export const CHAT_GROUP_MAX_OTHER_MEMBERS = 99;
/** Slow-mode choices offered to moderators, in seconds (the server allows 0–600). */
export const CHAT_SLOW_MODE_OPTIONS = [0, 10, 30, 60, 300, 600] as const;
/** Links to these sites (and their subdomains) open without the "leaving Espotz" warning. */
export const CHAT_TRUSTED_LINK_HOSTS = ['espotz.live'] as const;
/** The people search needs this many characters (the server takes 2–40). */
export const CHAT_PEOPLE_SEARCH_MIN_LENGTH = 2;
export const CHAT_PEOPLE_SEARCH_MAX_LENGTH = 40;

/** How often the members panel refreshes who has the chat open, while it is showing. */
export const CHAT_ONLINE_POLL_MS = 30_000;

/** Every report reason, in picker order. */
export const CHAT_REPORT_REASONS: readonly ChatReportReason[] =
  Object.values(ChatReportReason);

/** The inbox filter chips, in order; the types sit behind the Type menu, Requests is its own entry. */
export const CHAT_INBOX_FILTER_CHIPS: readonly InboxFilter[] = [
  InboxFilter.ALL,
  InboxFilter.UNREAD,
];

/** The chat types in the inbox's Type menu, in order. */
export const CHAT_INBOX_TYPE_FILTERS: readonly InboxFilter[] = [
  InboxFilter.TOURNAMENTS,
  InboxFilter.CLANS,
  InboxFilter.TEAMS,
  InboxFilter.ORGANIZATIONS,
  InboxFilter.DIRECT,
  InboxFilter.GROUPS,
];
